// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-bar-actions {\n  display: flex;\n  flex-direction: row;\n  justify-content: end;\n  height: 36px;\n  margin-top: 4px;\n  font-size: 16px;\n}\n\n.members-text {\n  display: flex;\n  align-items: center;\n}\n\n.incall-info {\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
